/**
 * 🧱 Refactor BT Phase 3 — Étape 2 : section « SectionDescriptionNotes » d'EditerBonTravailDialog.jsx.
 * JSX déplacé TEL QUEL (ex-L1028-1088, dédenté de 10) ; variables lues via `useBTForm()`
 * (BTFormProvider enrichi par `extra` dans le composant parent). DOM, data-testid, classes, textes inchangés.
 */
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { EditorRiche } from '@/components/crm/EditorRiche';
import { IAValidationButton } from '../../BTSubComponents';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { useBTForm } from '../../BTFormContext';

export function SectionDescriptionNotes() {
  const {
    employees,
    form,
    setForm,
  } = useBTForm();
  return (
    <>
      {/* Description + Notes */}
      <Card>
        <CardHeader><CardTitle className="text-base">Description des travaux</CardTitle></CardHeader>
        <CardContent className="space-y-4">
          {/* 🆕 2026-05-08 — Éditeur de texte riche TipTap (gras / italique / surligné /
              titres / listes). Visible uniquement dans ce formulaire — l'aperçu et l'impression
              du BT affichent du texte plat (HTML stripé). */}
          <EditorRiche
            value={form.description_travaux || ''}
            onChange={(html) => setForm(f => ({ ...f, description_travaux: html }))}
            minHeight="160px"
          />
          <div>
            <Label>Notes spéciales</Label>
            <div className="mt-1">
              <EditorRiche
                value={form.notes_speciales || ''}
                onChange={(html) => setForm(f => ({ ...f, notes_speciales: html }))}
                minHeight="120px"
              />
            </div>
          </div>

          {/* Validation IA — vérifier les contraintes de flotte */}
          <IAValidationButton form={form} employees={employees} />

          {/* Notes importantes — visibles dans le Dashboard Production à venir */}
          <div className="border-t pt-3 mt-1">
            <Label className="flex items-center gap-1.5 text-amber-700 font-semibold">
              <span>⚠</span> Notes importantes (visibles dans Vue d'ensemble)
            </Label>
            <p className="text-xs text-slate-400 mb-1.5">Ex: Greg doit partir avec la grosse remorque, apporter la nacelle la veille...</p>
            <Textarea
              value={form.notes_importantes}
              onChange={(e) => setForm(f => ({ ...f, notes_importantes: e.target.value }))}
              rows={2}
              placeholder="Ces notes apparaîtront dans le tableau Production à venir du Dashboard avec le nom du client..."
              className="border-amber-300 focus:ring-amber-400 bg-amber-50/30"
              data-testid="notes-importantes-bt"
            />
            {form.notes_importantes && (
              <div className="mt-2">
                <Label className="text-xs text-slate-600">Quand s'applique cette note ?</Label>
                <select
                  value={form.notes_importantes_timing}
                  onChange={(e) => setForm(f => ({ ...f, notes_importantes_timing: e.target.value }))}
                  className="w-full mt-1 border border-amber-300 rounded-md px-3 py-2 text-sm bg-amber-50/20 focus:outline-none focus:ring-2 focus:ring-amber-300"
                  data-testid="notes-importantes-timing"
                >
                  <option value="avant_debut">Avant le début des travaux (veille de la 1ère journée)</option>
                  <option value="debut_travaux">Début des travaux (1ère journée)</option>
                  <option value="pendant">Pendant les travaux</option>
                  <option value="fin_travaux">Fin des travaux (dernière journée)</option>
                  <option value="apres_fin">Après les travaux</option>
                </select>
              </div>
            )}
          </div>
        </CardContent>
      </Card>

    </>
  );
}
